import {
	useFormErrorNotification,
	useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { AddShopMemberDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";

type UseInviteTeamMemberParams = {
	onSuccess?: () => void;
	onError?: () => void;
};

export default function useInviteTeamMember(
	shopId: string,
	options?: UseInviteTeamMemberParams,
) {
	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();
	const mutation = $api.useMutation("post", "/shops/{shopId}/members/{email}");
	const invalidateShop = useInvalidateShop(shopId);

	return useMutation({
		onSuccess: () => {
			invalidateShop();
			successNotification();
			options?.onSuccess?.();
		},
		onError: () => {
			errorNotification();
			options?.onError?.();
		},
		mutationFn: async ({
			email,
			roleId,
			storeId,
		}: {
			email: string;
			roleId: AddShopMemberDto["roleId"];
			storeId?: string;
		}) => {
			return mutation.mutateAsync({
				params: { path: { shopId, email } },
				body: {
					roleId,
					storeId,
				},
			});
		},
	});
}
